// extracted by mini-css-extract-plugin
module.exports = {"selectInput":"orderSort_selectInput__3MDuO","select":"orderSort_select__2oX1I","selectIcon":"orderSort_selectIcon__19ZmY"};